import { Container } from "@mui/material";
import AuthorizationEditor from "../../components/authorization/editor";

export default function AuthorizationPage() {
  return (
    <Container
      maxWidth="lg"
      sx={{
        flex: 1,
        display: "flex",
        p: { xs: 2, md: 3 },
      }}
    >
      <AuthorizationEditor />
    </Container>
  );
}
